module.exports = __webpack_public_path__ + "img/crypto-bch.8d353337.svg";